// TODO: remove this once more exports are added
// eslint-disable-next-line import/prefer-default-export
export const API_ERROR = 'ApiError';
